/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesInvoicesDtosInvoiceDto,
  FacilityFlowCoreModulesInvoicesWorkflowsBulkCreateInvoicesRequest,
  FacilityFlowCoreModulesInvoicesWorkflowsBulkCreateInvoicesResponse,
  FacilityFlowCoreModulesInvoicesWorkflowsBulkCreateStandingInvoicesRequest,
  FacilityFlowCoreModulesInvoicesWorkflowsCreateInvoiceRequest,
  FacilityFlowCoreModulesInvoicesWorkflowsCreateInvoiceResponse,
  FacilityFlowCoreModulesInvoicesWorkflowsCreateManualInvoiceRequest,
  FacilityFlowCoreModulesInvoicesWorkflowsCreateStandingInvoiceRequest,
  FacilityFlowCoreModulesInvoicesWorkflowsGetBillableObjectsResponse,
  FacilityFlowCoreModulesInvoicesWorkflowsIssueInvoiceResponse,
  FacilityFlowCoreModulesInvoicesWorkflowsRenderInvoiceSnippetRequest,
  FacilityFlowCoreModulesInvoicesWorkflowsRenderInvoiceSnippetResponse,
  FacilityFlowCoreModulesInvoicesWorkflowsSearchInvoicesResponse,
  FacilityFlowCoreModulesInvoicesWorkflowsUpdateInvoiceRequest,
  GetApiV1InvoicesBillableObjectsParams,
  GetApiV1InvoicesBillableObjectsStandingParams,
  GetApiV1InvoicesParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getInvoices = () => {
/**
 * @summary Search invoices with optional filters, sorting and pagination. Sorting is applied
before paging; default is object A–Z, then period newest first.
`groupByObject` keeps the object groups and sorts by `sortBy` inside them.
 */
const getApiV1Invoices = (
    params?: GetApiV1InvoicesParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesWorkflowsSearchInvoicesResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesWorkflowsSearchInvoicesResponse>(
      {url: `/api/v1/invoices`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Create a draft monthly invoice for a single object and month. An object billed by
standing invoice, or a month covered by a standing invoice, gets only one-off,
by-effort and ad-hoc work — its fixed amounts are on the standing invoice.
 */
const postApiV1Invoices = (
    facilityFlowCoreModulesInvoicesWorkflowsCreateInvoiceRequest: FacilityFlowCoreModulesInvoicesWorkflowsCreateInvoiceRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesWorkflowsCreateInvoiceResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesWorkflowsCreateInvoiceResponse>(
      {url: `/api/v1/invoices`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesInvoicesWorkflowsCreateInvoiceRequest
    },
      options);
    }
  /**
 * @summary Get invoice by ID including all positions.
 */
const getApiV1InvoicesId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesDtosInvoiceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesDtosInvoiceDto>(
      {url: `/api/v1/invoices/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update the header of a draft invoice (contact person, texts, payment terms,
buyer reference, service period). Rejected once the invoice is issued.
 */
const putApiV1InvoicesId = (
    id: string,
    facilityFlowCoreModulesInvoicesWorkflowsUpdateInvoiceRequest: FacilityFlowCoreModulesInvoicesWorkflowsUpdateInvoiceRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesDtosInvoiceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesDtosInvoiceDto>(
      {url: `/api/v1/invoices/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesInvoicesWorkflowsUpdateInvoiceRequest
    },
      options);
    }
  /**
 * @summary Delete a draft invoice. Issued invoices cannot be deleted — cancel them instead.
 */
const deleteApiV1InvoicesId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/invoices/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Get the proposal list of objects that can be invoiced for the given period.
 */
const getApiV1InvoicesBillableObjects = (
    params?: GetApiV1InvoicesBillableObjectsParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesWorkflowsGetBillableObjectsResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesWorkflowsGetBillableObjectsResponse>(
      {url: `/api/v1/invoices/billable-objects`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Get the proposal list for the standing-invoice run: objects billed by standing
invoice with an active offer and, for the service period from–to
(whole months) paid every interval, the regular payment, the amount
over the period, a differing last payment of a service year and what blocks creation.
 */
const getApiV1InvoicesBillableObjectsStanding = (
    params?: GetApiV1InvoicesBillableObjectsStandingParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesWorkflowsGetBillableObjectsResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesWorkflowsGetBillableObjectsResponse>(
      {url: `/api/v1/invoices/billable-objects/standing`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Create a manual draft invoice for a customer with free-text positions.
No active offer required; ObjectId is optional.
 */
const postApiV1InvoicesManual = (
    facilityFlowCoreModulesInvoicesWorkflowsCreateManualInvoiceRequest: FacilityFlowCoreModulesInvoicesWorkflowsCreateManualInvoiceRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesWorkflowsCreateInvoiceResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesWorkflowsCreateInvoiceResponse>(
      {url: `/api/v1/invoices/manual`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesInvoicesWorkflowsCreateManualInvoiceRequest
    },
      options);
    }
  /**
 * @summary Create draft invoices in bulk for the selected objects. Per-object failures
are reported in the response without aborting the batch.
 */
const postApiV1InvoicesBulk = (
    facilityFlowCoreModulesInvoicesWorkflowsBulkCreateInvoicesRequest: FacilityFlowCoreModulesInvoicesWorkflowsBulkCreateInvoicesRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesWorkflowsBulkCreateInvoicesResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesWorkflowsBulkCreateInvoicesResponse>(
      {url: `/api/v1/invoices/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesInvoicesWorkflowsBulkCreateInvoicesRequest
    },
      options);
    }
  /**
 * @summary Create the standing invoice („Dauerrechnung") of an object billed by standing
invoice for the chosen service period (whole months) and payment interval: the fixed
amounts of one regular payment plus the payment plan, the last payment of a service
year taking the rounding difference.
 */
const postApiV1InvoicesStanding = (
    facilityFlowCoreModulesInvoicesWorkflowsCreateStandingInvoiceRequest: FacilityFlowCoreModulesInvoicesWorkflowsCreateStandingInvoiceRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesWorkflowsCreateInvoiceResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesWorkflowsCreateInvoiceResponse>(
      {url: `/api/v1/invoices/standing`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesInvoicesWorkflowsCreateStandingInvoiceRequest
    },
      options);
    }
  /**
 * @summary Create standing invoices in bulk for the selected objects. Per-object failures
are reported in the response without aborting the batch.
 */
const postApiV1InvoicesStandingBulk = (
    facilityFlowCoreModulesInvoicesWorkflowsBulkCreateStandingInvoicesRequest: FacilityFlowCoreModulesInvoicesWorkflowsBulkCreateStandingInvoicesRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesWorkflowsBulkCreateInvoicesResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesWorkflowsBulkCreateInvoicesResponse>(
      {url: `/api/v1/invoices/standing/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesInvoicesWorkflowsBulkCreateStandingInvoicesRequest
    },
      options);
    }
  /**
 * @summary Transition a draft invoice to Issued, allocating a number and stamping
supplier/buyer snapshots. Idempotent.
 */
const postApiV1InvoicesIdIssue = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesWorkflowsIssueInvoiceResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesWorkflowsIssueInvoiceResponse>(
      {url: `/api/v1/invoices/${id}/issue`, method: 'POST'
    },
      options);
    }
  const postApiV1InvoicesIdSend = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/invoices/${id}/send`, method: 'POST'
    },
      options);
    }
  const postApiV1InvoicesIdPay = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/invoices/${id}/pay`, method: 'POST'
    },
      options);
    }
  const postApiV1InvoicesIdCancel = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/invoices/${id}/cancel`, method: 'POST'
    },
      options);
    }
  /**
 * @summary Render the invoice as a PDF document.
 */
const getApiV1InvoicesIdPdf = (
    id: string,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/v1/invoices/${id}/pdf`, method: 'GET',
        responseType: 'blob'
    },
      options);
    }
  /**
 * @summary Render an invoice text body for the live preview in the invoice forms. Replaces
the placeholders that can be resolved from the given context ({CustomerName},
{BillingPeriod}, {Greeting}, …) and leaves the rest untouched.
 */
const postApiV1InvoicesRenderSnippet = (
    facilityFlowCoreModulesInvoicesWorkflowsRenderInvoiceSnippetRequest: FacilityFlowCoreModulesInvoicesWorkflowsRenderInvoiceSnippetRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesWorkflowsRenderInvoiceSnippetResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesWorkflowsRenderInvoiceSnippetResponse>(
      {url: `/api/v1/invoices/render-snippet`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesInvoicesWorkflowsRenderInvoiceSnippetRequest
    },
      options);
    }
  return {getApiV1Invoices,postApiV1Invoices,getApiV1InvoicesId,putApiV1InvoicesId,deleteApiV1InvoicesId,getApiV1InvoicesBillableObjects,getApiV1InvoicesBillableObjectsStanding,postApiV1InvoicesManual,postApiV1InvoicesBulk,postApiV1InvoicesStanding,postApiV1InvoicesStandingBulk,postApiV1InvoicesIdIssue,postApiV1InvoicesIdSend,postApiV1InvoicesIdPay,postApiV1InvoicesIdCancel,getApiV1InvoicesIdPdf,postApiV1InvoicesRenderSnippet}};
export type GetApiV1InvoicesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['getApiV1Invoices']>>>
export type PostApiV1InvoicesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['postApiV1Invoices']>>>
export type GetApiV1InvoicesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['getApiV1InvoicesId']>>>
export type PutApiV1InvoicesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['putApiV1InvoicesId']>>>
export type DeleteApiV1InvoicesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['deleteApiV1InvoicesId']>>>
export type GetApiV1InvoicesBillableObjectsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['getApiV1InvoicesBillableObjects']>>>
export type GetApiV1InvoicesBillableObjectsStandingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['getApiV1InvoicesBillableObjectsStanding']>>>
export type PostApiV1InvoicesManualResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['postApiV1InvoicesManual']>>>
export type PostApiV1InvoicesBulkResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['postApiV1InvoicesBulk']>>>
export type PostApiV1InvoicesStandingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['postApiV1InvoicesStanding']>>>
export type PostApiV1InvoicesStandingBulkResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['postApiV1InvoicesStandingBulk']>>>
export type PostApiV1InvoicesIdIssueResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['postApiV1InvoicesIdIssue']>>>
export type PostApiV1InvoicesIdSendResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['postApiV1InvoicesIdSend']>>>
export type PostApiV1InvoicesIdPayResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['postApiV1InvoicesIdPay']>>>
export type PostApiV1InvoicesIdCancelResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['postApiV1InvoicesIdCancel']>>>
export type GetApiV1InvoicesIdPdfResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['getApiV1InvoicesIdPdf']>>>
export type PostApiV1InvoicesRenderSnippetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoices>['postApiV1InvoicesRenderSnippet']>>>
